import { MileageMultiRateInfo, IMileageMultiRateInfo } from "./mileage-multi-rate-info";

export interface IUkRateInfo {
    userId: number;
    actionId: number;
    orgVehicleTypeMapId: number;
    organisationId: number;
    vehicleTypeId: number;
    baseName: string;
    derivedName: string;
    mileageRate: number;
    isActive: boolean;
    isDefault: boolean;
    vehicleSubTypeId: number;
    rateType: number;
    isMultiRange: boolean;
    sequence: number;
    vehicleTypeName: string;
    vehicleSubTypeName: string;
    vehicleLabel: string;
    effectiveFrom: string;
    vatRate: number;
    vatRateId: number;
    mileageMultiRateInfoList: IMileageMultiRateInfo[];
    nrFuelRate: number;
    chargingType: number;

}


export class UkRateInfo implements IUkRateInfo {
    userId: number = 0;
    actionId: number = 0;
    orgVehicleTypeMapId: number = 0;
    organisationId: number = 0;
    vehicleTypeId: number = 0;
    baseName: string;
    derivedName: string;
    mileageRate: number = 0;
    isActive: boolean = false;
    isDefault: boolean = false;
    vehicleSubTypeId: number = 0;
    rateType: number = 0;
    isMultiRange: boolean = false;
    sequence: number = 0;
    vehicleTypeName: string;
    vehicleSubTypeName: string;
    vehicleLabel: string;
    effectiveFrom: string;
    vatRate: number = 0;
    vatRateId: number = 0;
    mileageMultiRateInfoList: MileageMultiRateInfo[];
    nrFuelRate: number;
    chargingType: number = 0;
}

export class SaveOwnershiptypeRequest {
    ownershiptypeList: UkRateInfo[];
    action: number = 0;
    deleteActivationRequest: boolean = false;
}